"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PaddedDecimal = _interopRequireDefault(require("../common/PaddedDecimal/PaddedDecimal"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _CancelAPButton = _interopRequireDefault(require("../common/CancelAPButton"));
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var orderBookClasses = (0, _cssClassesHelper.getBEMClasses)('orderbook');
var flexTable = (0, _cssClassesHelper.getBEMClasses)('flex-table');
var flexTableColumn = flexTable('column');
var cancelClassName = "".concat(flexTableColumn, " ").concat(orderBookClasses('cancel-btn'));
var Level2DataTableComponent = function Level2DataTableComponent(props) {
  var cancelOrders = props.cancelOrders,
    onPriceClick = props.onPriceClick,
    onQuantityClick = props.onQuantityClick,
    level2Data = props.level2Data,
    classModifier = props.classModifier,
    fetching = props.fetching,
    _props$showAccumulate = props.showAccumulatedSum,
    showAccumulatedSum = _props$showAccumulate === void 0 ? false : _props$showAccumulate;
  var rowClassName = "".concat(flexTable('row'), " ").concat(orderBookClasses('order-row', classModifier));
  var priceClassName = "".concat(flexTableColumn, " ").concat(orderBookClasses('table-price', classModifier));
  var quantityClassName = "".concat(flexTableColumn, " ").concat(orderBookClasses('table-qty', classModifier));
  var sumClassName = "".concat(flexTableColumn, " ").concat(orderBookClasses('table-sum', classModifier));
  if (fetching) {
    return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
      customClass: orderBookClasses,
      classModifiers: classModifier
    });
  } else {
    return level2Data.map(function (data, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: data.Price,
        className: rowClassName
      }, /*#__PURE__*/_react["default"].createElement("div", {
        "data-price": data.Price,
        onClick: onPriceClick,
        className: priceClassName
      }, /*#__PURE__*/_react["default"].createElement(_PaddedDecimal["default"], {
        bemMod: classModifier,
        value: data.Price,
        decimals: props.priceDecimalPlaces
      })), /*#__PURE__*/_react["default"].createElement("div", {
        "data-quantity": data.Quantity,
        "data-index": index,
        onClick: onQuantityClick,
        className: quantityClassName
      }, /*#__PURE__*/_react["default"].createElement(_PaddedDecimal["default"], {
        value: data.Quantity,
        decimals: props.quantityDecimalPlaces
      })), showAccumulatedSum && /*#__PURE__*/_react["default"].createElement("div", {
        className: sumClassName
      }, /*#__PURE__*/_react["default"].createElement(_PaddedDecimal["default"], {
        value: data.AccumulatedSum,
        decimals: props.quantityDecimalPlaces
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: cancelClassName
      }, data.MySize && /*#__PURE__*/_react["default"].createElement(_CancelAPButton["default"], {
        onClick: function onClick() {
          if (data.OrderIds.length) {
            cancelOrders(data.OrderIds);
          } else {
            cancelOrders([data.OrderId]);
          }
        },
        text: "",
        customClass: orderBookClasses()
      })));
    });
  }
};
Level2DataTableComponent.propTypes = {
  cancelOrders: _propTypes["default"].func.isRequired,
  onPriceClick: _propTypes["default"].func.isRequired,
  onQuantityClick: _propTypes["default"].func.isRequired,
  level2Data: _propTypes["default"].array.isRequired,
  classModifier: _propTypes["default"].string,
  fetching: _propTypes["default"].bool,
  showAccumulatedSum: _propTypes["default"].bool
};
var _default = exports["default"] = Level2DataTableComponent;